import React, { Component } from "react";

export default class JSObjects extends Component {

    render() {

        return(<div>Placeholder.</div>);

    }
    
}